import { useContext, useEffect, useState } from 'react';
import _get from 'lodash/get';

import { AppContext } from 'commons-ui';
import useService from './useService';

const useKycDocsHistory = () => {
	const [kycDocsIsCollapsed, setKycDocsIsCollapsed] = useState<boolean>(true);
	const [dataFetchComplete, setDataFetchComplete] = useState<boolean>(false);
	const [kycDocsData, setKycDocsData] = useState<any>([]);
	const [showLoader, setShowLoader] = useState<boolean>(false);
	const { showAlert } = useContext(AppContext);
	const { listKycDocumentsHistory } = useService();

	const fetchRowData = async () => {
		try {
			setShowLoader(true);
			const fetchedData = await listKycDocumentsHistory();
			setKycDocsData({ rowCount: fetchedData.rowCount, data: fetchedData.data });
			setDataFetchComplete(true);
		} catch (error: any) {
			showAlert(_get(error, 'error', 'Error while fetching data.'), { type: 'error' });
		} finally {
			setShowLoader(false);
		}
	};

	useEffect(() => {
		if (!dataFetchComplete) {
			fetchRowData();
		}
	}, [kycDocsIsCollapsed]);

	const handleDatalistFetchData = () => {
		return kycDocsData;
	};

	return {
		kycDocsIsCollapsed,
		setKycDocsIsCollapsed,
		showLoader,
		handleDatalistFetchData,
		dataFetchComplete
	};
};

export default useKycDocsHistory;
